import React, {useEffect} from "react";
import styled from "styled-components";
import {Col, Descriptions, Form, Input, Row} from "antd";
import {useStore} from "../../store";

const BaseLibraryDetail:React.FC = () => {
    const [form] = Form.useForm();
    const {baseLibraryStore} = useStore();
    useEffect(() => {
        form.setFieldsValue(baseLibraryStore.showBaseLibraryDetail)
    },[])
    return(<Wrapper>
        <Form  disabled={true} labelAlign={"right"} wrapperCol={{span:"15"}} title={"基础库编辑"} form={form} layout={"horizontal"} size={"middle"} style={{maxHeight: "400px", overflow: "hidden"}}>
            <Row justify={"space-between"} gutter={[15, 15]}>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"物种中文名"} name={"speciesZhName"} required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"物种拉丁文"} name={"canonicalName"} required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"物种采集人"} name={"speciesAuthor"} required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"属"} name={"genus"} required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"纲"} name={"speciesClass"} required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"目"} name={"speciesOrder"} required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"科"} name={"speciesFamily"} required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"科中文名"} name={"speciesFamilyName"} required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"属中文名"} name={"genusName"} required={false}><Input/></Form.Item></Col>
                <Col span={12}><Form.Item labelCol={{span:"8"}} label={"种加词"} name={"species"} required={false}><Input/></Form.Item></Col>
            </Row>
        </Form>
        {/*<Descriptions  layout={"horizontal"} bordered={true} column={2}>*/}
        {/*    <Descriptions.Item label={"物种中文名"}>{baseLibraryStore.showBaseLibraryDetail?.speciesZhName}</Descriptions.Item>*/}
        {/*    <Descriptions.Item label={"物种拉丁文"}>{baseLibraryStore.showBaseLibraryDetail?.canonicalName}</Descriptions.Item>*/}
        {/*    <Descriptions.Item label={"物种采集人"}>{baseLibraryStore.showBaseLibraryDetail?.speciesAuthor}</Descriptions.Item>*/}
        {/*    <Descriptions.Item label={"属"}>{baseLibraryStore.showBaseLibraryDetail?.genus}</Descriptions.Item>*/}
        {/*    <Descriptions.Item label={"纲"}>{baseLibraryStore.showBaseLibraryDetail?.speciesClass}</Descriptions.Item>*/}
        {/*    <Descriptions.Item label={"目"}>{baseLibraryStore.showBaseLibraryDetail?.speciesOrder}</Descriptions.Item>*/}
        {/*    <Descriptions.Item label={"科"}>{baseLibraryStore.showBaseLibraryDetail?.speciesFamily}</Descriptions.Item>*/}
        {/*    <Descriptions.Item label={"科中文名"}>{baseLibraryStore.showBaseLibraryDetail?.speciesFamilyName}</Descriptions.Item>*/}
        {/*    <Descriptions.Item label={"创建时间"}>{baseLibraryStore.showBaseLibraryDetail?.createtime}</Descriptions.Item>*/}
        {/*    <Descriptions.Item label={"属中文名"}>{baseLibraryStore.showBaseLibraryDetail?.genusName}</Descriptions.Item>*/}
        {/*    <Descriptions.Item label={"种加词"}>{baseLibraryStore.showBaseLibraryDetail?.species}</Descriptions.Item>*/}
        {/*</Descriptions>*/}

    </Wrapper>);
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
`;
export default BaseLibraryDetail;